import http from '../../http-common';

/**
 * @author André
 * 24/08/2022
 **/

const url = '/Dragndrop/';

export const DefaultDragNDropService = {
    CustomFileUploaderClient(data) {
        return http.post(`${url}RemoveClientImage`, data)
    },
    CustomFileUploaderUser(data) {
        return http.post(`${url}RemoveUserImage`, data)
    },
    CustomFileUploaderOperator(data) {
        return http.post(`${url}RemoveOperatorImage`, data)
    },
    CustomFileUploaderClientLogo(data) {
        return http.post("Client/RemoveClientImage", data)
    },
}